/**
 * @generated SignedSource<<5961fe80fbbe90483f7e548dd233d070>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRow_packageDate$data = {
  readonly end: string;
  readonly flight: {
    readonly forwardChangeDuration: string | null;
    readonly forwardFlightNumber: string | null;
    readonly forwardSegments: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"FlightSegments_segments">;
    }>;
    readonly id: string;
    readonly priceLive: number;
    readonly returnChangeDuration: string | null;
    readonly returnFlightNumber: string | null;
    readonly returnSegments: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"FlightSegments_segments">;
    }>;
  } | null;
  readonly id: string;
  readonly start: string;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_packageDate">;
  readonly " $fragmentType": "PackageEditTransportFlightsRow_packageDate";
};
export type PackageEditTransportFlightsRow_packageDate$key = {
  readonly " $data"?: PackageEditTransportFlightsRow_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRow_packageDate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FlightSegments_segments"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRow_packageDate",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forwardFlightNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "returnFlightNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forwardChangeDuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "returnChangeDuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceLive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FlightSegment",
          "kind": "LinkedField",
          "name": "forwardSegments",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FlightSegment",
          "kind": "LinkedField",
          "name": "returnSegments",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlightsRowActions_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};
})();

(node as any).hash = "01ddb4538a5c816656fcd8a9329fa6d4";

export default node;
